import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_letter_tile = _resolveComponent("letter-tile")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.letters, (letter, index) => {
    return (_openBlock(), _createBlock(_component_letter_tile, {
      color: _ctx.color,
      key: `guess-letter-${index}`,
      letter: letter
    }, null, 8, ["color", "letter"]))
  }), 128))
}